import { config } from 'env_def';
const contextPath = config('contextPath');
const domain = config('webMailBJHost');
const url = process.env.BUILD_ISELECTRON ? `${domain}/static/sirius-web` : `${contextPath}`;
export const fontFaceStyles = `
  @font-face {
    font-family: 'Source Han Sans';
    src: url('${url}/思源黑体.ttf');
  }
  @font-face {
    font-family: 'lucida grande';
    src: url('${url}/LucidaGrande.otf');
  }
  @font-face {
    font-family: 'uverdana';
    src: url('${url}/uverdana.ttf');
  }
  @font-face {
    font-family: 'simhei';
    src: url('${url}/黑体.ttf');
  }
  @font-face {
    font-family: 'menlo';
    src: url('${url}/menlo-regular.ttf');
  }
  @font-face {
    font-family: 'verdana';
    src: url('${url}/verdana.ttf');
  }
  @font-face {
    font-family: 'geneva';
    src: url('${url}/verdana.ttf');
  }
  @font-face {
    font-family: 'KaiTi';
    src: url('${url}/楷体.ttf');
  }
`;
